
import { FreeBlock } from "@/utils/documents/free-block";
import AppSelectPlacement from "./SelectPlacement.vue";
import Vue from "vue";
import { DocumentLayoutLogoPosition } from "@/utils/documents/layout-logo";
import AppFieldsEdit from "./FieldsEdit.vue";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";

export default Vue.extend({
	data(){
		return {
			name: ""
		};
	},
	props: {
		value: {
			type: Object as ()=>FreeBlock,
			required: true
		},
		index: {
			type: Number,
			required: true
		},
		layout: {
			type: Object as ()=>ReminderLayout,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.name = this.value.getName(this.index);
			}
		}
	},
	methods: {
		setPlacement(value:DocumentLayoutLogoPosition){
			this.value.Placement = value;
			this.value.X = 0;
			this.value.Y = 0;
		},
		onNameInput(input:string){
			this.name = input;
			this.value.Name = this.name;
		}
	},
	components: {
		AppFieldsEdit,
		AppSelectPlacement
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
